export const recentRecord = {
  title: "Recent Records Visited",
  headers: ["Data", "Type"],
  data: [
    {
      name: "La Terra Santa Monica",
      tracking: false,
      type: "Company"
    },
    {
      name: "La Terra Santa",
      tracking: true,
      type: "Project"
    },
    {
      name: "British Columbia",
      tracking: true,
      type: "Territory"
    },
    {
      name: "Oak Grove Racing & Gaming Project",
      tracking: true,
      type: "Company"
    }
  ]
};
